import { getTrackById } from "../assets/asset_loaders/tracks";

/**
 * Converts a World cup array to a shareable string format
 * Focuses on ending locations as the primary race destination
 * @param {Array} cup - Array of 4 track objects with start and end properties
 * @returns {String} - Formatted string representation of the cup
 */
export default function cupToString(cup) {
    let cupString = "";
    
    cup.forEach((track, index) => {
        if (track) {
            const startTrack = getTrackById(track.start);
            const endTrack = track.end ? getTrackById(track.end) : null;
            
            cupString += `${index + 1}. `;
            
            if (endTrack && startTrack.id !== endTrack.id) {
                // Highway race: start → end (race ends at endTrack)
                cupString += `${startTrack.name} → ${endTrack.name}\n`;
            } else {
                // Full race at single track (race ends at startTrack)
                cupString += `${startTrack.name}\n`;
            }
        }
    });
    
    return cupString;
}
